'use strict';

angular.module('linagora.esn.controlcenter')
  .constant('CONTROLCENTER_GENERAL_CONFIGS', ['homePage', 'businessHours', 'datetime', 'language']);
